// extracted by mini-css-extract-plugin
export var disabled = "_z-a";
export var hierarchyLinkGray = "_z-4";
export var hierarchyLinkUnderline = "_z-3";
export var hierarchyPrimary = "_z-0";
export var hierarchySecondary = "_z-1";
export var hierarchyTertiary = "_z-2";
export var pressed = "_z-6";
export var themeAction = "_z-5";
export var themeDestructive = "_z-8";
export var themeNormal = "_z-7";
export var themeSuccess = "_z-9";